import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import {FeatureUsageQuota} from '../__generated__/resolvers-types';

export const GET_FEATURE_USAGE_QUOTA_QUERY = gql`
  query GetFeatureUsageQuotaQuery {
    getFeatureUsageWithQuota {
      id
      usage
      quota
    }
  }
`;

/**
 * Get and monitor feature usage quota information
 * @returns undefined when loading, null when not logged in, FeatureUsageQuota[] when found
 */
export default function useGetFeatureUsageQuota() {
  const {data, error, loading, refetch} = useQuery<{getFeatureUsageWithQuota: FeatureUsageQuota[]}>(
    GET_FEATURE_USAGE_QUOTA_QUERY,
  );

  return {loading, error, data: data?.getFeatureUsageWithQuota || [], refetchFeatureUsageQuota: refetch};
}
